// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3cvxH","choiceBoxes":"toolbarselects_choiceBoxes__3BE2k","simpleField":"toolbarselects_simpleField__1cZsL"};